import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BusinessCoupon } from "app/public/model/BusinessCoupon";
import { Observable, share } from "rxjs";

@Injectable()
export class CouponService {
    constructor(private httpClient: HttpClient) { }
    getCoupon(couponNum) {
        return this.httpClient.get(`/coupon/${couponNum}`);
    }
    implementCoupon(couponNum) {
        return this.httpClient.post(`/coupon/implementCoupon`, { couponNum });
    }
    resendWinningEmail(couponCode: string) {
        return this.httpClient.post(`/coupon/resendWinningEmail`, { couponCode });
    }
    getCoupons(request:any): Observable<{BuisnessCoupons:BusinessCoupon[],TotalCount:number}> {
        return this.httpClient.post<{BuisnessCoupons:BusinessCoupon[],TotalCount:number}>('/coupon',request).pipe(share());
    }
    exportBusinessCouponToExcel(bussinessId: number, filter: any,Paging: any)
    {
      return this.httpClient.post('/coupon/exportCouponsToExcel', {
        bussinessId,
        filter,
        Paging,
      },
        { responseType: "blob", headers: { Accept: 'application/octet-stream' } })
    }
}